// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"154":"customers","382":"tickets","389":"404","809":"users","835":"chat_settings","945":"dashboard"}[chunkId] + "." + {"154":"c0b802df","382":"94a7493d","389":"7f58e61a","809":"d136833b","835":"09ee5ec4","945":"b9b23893"}[chunkId] + ".css";
};